export default "__VITE_ASSET__BVwjoagS__"